import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from "../../store/slices/currentUser";
import {
  tryGetStudentsAll,
  selectBackStudents,
  selectStudentMails,
  tryGetStudentMails,
  tryGetStudentsReport,
  tryGetStudentsReportWithDni,
  tryExportStudentsAll,
  selectExportedStudents,
  selectDonwloadedStudentsReport,
} from "../../store/slices/backoffice-students";
import {
  Box,
  Chip,
  Grid,
  Grow,
  Paper,
  Popper,
  Button,
  IconButton,
  Tooltip,
  MenuItem,
  MenuList,
  Typography,
  useMediaQuery,
  ClickAwayListener,
} from "@mui/material";

import {
  Email,
  Download,
  PersonAdd,
  MoreHoriz,
  Assessment,
} from "@mui/icons-material";
import { useNavigate } from "react-router";
import CustomColumnMenu from "../layout/grid-column-menu";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import ModalMessages from "../layout/modal-messages";
import Spinner from "../layout/spinner";
import StudentsListSkeleton from "./skeleton";
import ModalMails from "./modal/mailModal";

const BackOfficeStudentsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMobile = useMediaQuery("(max-width:600px)");

  const currentUser = useSelector(selectCurrentUser);

  //TRAE EL DETALLE DE MAILS
  const studentMails = useSelector(selectStudentMails);

  //TRAE EL DETALLE DE LOS ALUMNOS
  const students = useSelector(selectBackStudents);

  //TRAE EL DETALLE DE LOS ALUMNOS EXPORTADOS
  const exportedSudents = useSelector(selectExportedStudents);

  //TRAE EL DETALLE DE LOS REPORTES
  const downloadedReport = useSelector(selectDonwloadedStudentsReport);

  //MANEJO DE LAS COLUMNAS
  const [rows, setRows] = useState([]);

  //MANEJO MODAL MAILS
  const [openModal, setOpenModal] = useState(false);
  const [mails, setMails] = useState(null);

  useEffect(() => {
    dispatch(tryGetStudentsAll());
  }, [dispatch]);

  useEffect(() => {
    if (students?.data) {
      setRows(
        students.data.map((x) => ({
          clientId: x.clientId,
          fullName: x.fullName,
          statusCli: x.statusCli,
          studentId: x.studentId,
          cuil: addDashes(x.cuil),
          userId: x.userId,
          unansweredTicket: x.unansweredTicket,
          activeCourses: x.activeCourses,
          condition: x.condition,
          coursesWait: x.coursesWait,
          pendingPayments: x.pendingPayments,
          username: x.username ? x.username.toString().trim().toLowerCase() : "",
          email: x.email ? x.email.toString().trim().toLowerCase() : "",
          studentTypeId: x.studentTypeId,
          statusCliId: x.statusCliId,
        }))
      );
    }
  }, [students]);

  //EXPORTA EL LISTADO DE ALUMNOS
  const handleClickExport = async () => {
    const action = await dispatch(tryExportStudentsAll());
    if (action.payload?.data?.isValid) window.open(action.payload.data.data.file);
  };

  //DESCARGA EL REPORTE DE ALUMNOS
  const handleClickReport = async () => {
    const action =
      currentUser.roleId === 1
        ? await dispatch(tryGetStudentsReportWithDni())
        : await dispatch(tryGetStudentsReport());

    if (action.payload?.data?.isValid) window.open(action.payload.data.data.file);
  };

  //AGREGA GUIONES A LOS CUILS
  function addDashes(number) {
    if (!number) return "";
    let strNumber = typeof number !== "string" ? number.toString() : number;
    if (strNumber.length <= 2) return strNumber;
    const pre = strNumber.slice(0, 2);
    const mid = strNumber.slice(2, -1);
    const last = strNumber.slice(-1);
    return `${pre}-${mid}-${last}`;
  }

  //ACCIONES Y COLUMNAS
  const initializeDataGrid = () => {
    return {
      columns: {
        columnVisibilityModel: {
          studentId: false,
          courseGroupId: false,
          userId: false,
          clientId: false,
          email: !isMobile,
          statusCliId: !isMobile,
          cuil: !isMobile,
          coursesWait: !isMobile,
          condition: !isMobile,
          activeCourses: !isMobile,
          pendingPayments: !isMobile,
          unansweredTicket: !isMobile,
          actions: !isMobile,
        },
      },
      pagination: { paginationModel: { pageSize: 10 } },
    };
  };

  //NAVEGAR
  const navigateNewStudent = () => navigate("/signup");

  //BOTON DE ACCIONES
  const ActionsRow = ({ item }) => {
    const anchorRef = useRef(null);
    const [openMenu, setOpenMenu] = useState(false);

    const handleMenuItemClick = (event, index) => {
      //ADMINISTRAR ALUMNO
      if (index === 0) {
        navigate("/students", {
          state: {
            studentId: item.row.studentId,
            userId: item.row.userId,
            clientId: item.row.clientId,
            username: item.row.username,
            studentCuil: item.row.cuil,
          },
        });
      }
      setOpenMenu(false);
    };

    const handleToggle = () => setOpenMenu((prevOpen) => !prevOpen);

    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) return;
      setOpenMenu(false);
    };

    return (
      <>
        <IconButton
          size="small"
          ref={anchorRef}
          aria-controls={openMenu ? "split-button-menu" : undefined}
          aria-expanded={openMenu ? "true" : undefined}
          aria-label="Acciones"
          aria-haspopup="menu"
          onClick={handleToggle}
          sx={{
            padding: "4px",
            backgroundColor: "#225275",
            color: "white",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: "#173b54",
            }
          }}
        >
          <MoreHoriz />
        </IconButton>

        <Popper
          sx={{ zIndex: 10 }}
          open={openMenu}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          placement="left-start"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper elevation={6}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    <MenuItem key="adminStudent" onClick={(event) => handleMenuItemClick(event, 0)}>
                      Administrar Alumno
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    );
  };

  //MANEJO SELECCION DE EMAILS
  const handleClickEmails = async (isActive) => {
    const action = await dispatch(tryGetStudentMails(isActive));
    if (action.payload?.data?.isValid) {
      setMails(action.payload.data.data);
      setOpenModal(true);
    }
  };

  const chipColorsState = {
    1: "success",
    2: "error",
    3: "warning",
  };

  const columns = React.useMemo(() => [
    { field: "clientId", headerName: "clientId", flex: 1, filterable: false },
    { field: "studentId", headerName: "studentId", flex: 1, filterable: false },
    { field: "userId", headerName: "userId", flex: 1, filterable: false },
    {
      field: "fullName",
      headerName: isMobile ? "Detalle del Alumno" : "Nombre Completo",
      flex: isMobile ? 1 : 2,
      minWidth: 180,
      headerClassName: "headRow",
      align: "left",
      headerAlign: isMobile ? "center" : "left",
      renderCell: (params) => {
        if (!isMobile) return <Typography variant="body2">{params.row.fullName}</Typography>;

        const chipColor = chipColorsState[params.row.statusCliId] || "default";

        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              textAlign: "left",
              width: "100%",
              position: "relative",
              pt: 2,
              pb: 3,
              pr: 2,
              boxSizing: "border-box"
            }}
          >
            <Box sx={{ position: "absolute", right: -8, top: 4 }}>
              <ActionsRow item={params} />
            </Box>

            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 800, color: "text.primary", pb: 1, width: "100%" }}
            >
              {params.row.fullName}
            </Typography>

            <Typography variant="caption" color="textSecondary" sx={{ pb: 1.5, width: "100%" }}>
              {params.row.cuil} • {params.row.condition?.replace("Frente a UTEDYC", "").trim()}
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "flex-start", width: "100%" }}>
              <Chip label={params.row.statusCli} color={chipColor} size="small" />

              {(params.row.activeCourses > 0 || params.row.coursesWait > 0) && (
                <Chip label={`Cursos: ${params.row.activeCourses} / ${params.row.coursesWait}`} size="small" variant="outlined" />
              )}

              {params.row.pendingPayments > 0 && (
                <Chip label={`Pagos: ${params.row.pendingPayments}`} color="error" size="small" />
              )}

              {params.row.unansweredTicket && (
                <Chip label="Tickets" color="warning" size="small" />
              )}
            </Box>
          </Box>
        );
      },
    },
    {
      field: "email",
      headerName: "Correo Electrónico",
      flex: 1.5,
      minWidth: 130,
      headerClassName: "headRow",
      renderCell: (params) => {
        const val = params.value?.toString() || "";
        if (val) {
          return <Typography variant="body2">{val}</Typography>;
        }
        return (
          <Typography variant="body2" color="text.disabled" sx={{ fontStyle: "italic" }}>
            Sin correo
          </Typography>
        );
      }
    },
    {
      field: "cuil",
      headerName: "CUIL/CUIT",
      width: 120,
      headerClassName: "headRow",
    },
    {
      field: "condition",
      headerName: "Condición Frente a UTEDYC",
      width: 120,
      headerClassName: "headRow",
      filterable: false,
    },
    {
      field: "activeCourses",
      headerAlign: "center",
      align: "center",
      headerName: "Cursos Activos",
      width: 80,
      headerClassName: "headRow",
      filterable: false,
      renderCell: (params) => (
        <Tooltip title="Cursos Activos/Espera" arrow>
          <Typography variant="body2">{`${params.row.activeCourses} / ${params.row.coursesWait}`}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "coursesWait",
      headerAlign: "center",
      align: "center",
      headerName: "Cursos en Espera",
      width: 80,
      headerClassName: "headRow",
      filterable: false,
    },
    {
      field: "pendingPayments",
      headerAlign: "center",
      align: "center",
      width: 80,
      headerName: "Pagos sin revisar",
      headerClassName: "headRow",
      filterable: false,
    },
    {
      field: "unansweredTicket",
      headerName: "Comunicaciones",
      align: "center",
      width: 80,
      headerClassName: "headRow",
      filterable: false,
      renderCell: (params) => {
        if (params.value === null) return "";
        return (
          <Chip
            label={params.value ? "SI" : "NO"}
            color={params.value ? "warning" : "success"}
            size="small"
          />
        );
      },
    },
    {
      field: "statusCliId",
      headerName: "Estado",
      align: "center",
      width: 80,
      headerClassName: "headRow",
      filterable: false,
      renderCell: (params) => {
        if (params.value === null) return "";
        const chipColor = chipColorsState[params.row.statusCliId] || "default";
        return <Chip label={params.row.statusCli} color={chipColor} size="small" />;
      },
    },
    {
      field: "actions",
      headerAlign: "center",
      headerName: "",
      width: 60,
      minWidth: 60,
      headerClassName: "headRow",
      filterable: false,
      align: "center",
      renderCell: (params) => <ActionsRow item={params} />,
    },
  ], [isMobile]);

  const CustomNoRowsOverlay = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          position: "sticky",
          left: 0,
        }}
      >
        <Typography variant="body1" color="textSecondary" sx={{ mt: 4 }}>
          No se encontraron alumnos con ese criterio.
        </Typography>
      </Box>
    );
  };

  const CustomToolbar = React.useCallback(() => {
    return (
      <Box sx={{ p: 2, display: "flex", justifyContent: isMobile ? "center" : "flex-start", width: "100%" }}>
        <GridToolbarQuickFilter
          placeholder="Buscar alumno, CUIL, etc..."
          variant="outlined"
          size="small"
          sx={{ 
            width: isMobile ? "100%" : "300px",
            pb: 1
          }}
        />
      </Box>
    );
  }, [isMobile]);

  return (
    <>
      {students.isLoading ? (
        <StudentsListSkeleton />
      ) : (
        <Grid container spacing={3} sx={{ pt: 3, pb: 3, minWidth: 0 }}>
          <Grid item xs={12} md={3}>
            <Typography align="left" style={{ fontWeight: "bold", fontSize: 18 }} variant="h6" component="h1">
              Alumnos
            </Typography>
          </Grid>

          <Grid item xs={12} md={9}>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "flex-end",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Button
                variant="contained"
                fullWidth={isMobile}
                disabled={studentMails.isLoading}
                endIcon={<Email />}
                onClick={() => handleClickEmails(false)}
              >
                {studentMails.isLoading && <Spinner color="primary" />} TODOS
              </Button>
              <Button
                variant="contained"
                fullWidth={isMobile}
                disabled={studentMails.isLoading}
                endIcon={<Email />}
                onClick={() => handleClickEmails(true)}
              >
                {studentMails.isLoading && <Spinner color="primary" />} CURSANDO
              </Button>
              <Button
                variant="contained"
                fullWidth={isMobile}
                disabled={students.isLoading || exportedSudents.isLoading}
                endIcon={<Download />}
                onClick={() => handleClickExport()}
              >
                {students.isLoading && <Spinner color="primary" />} EXPORTAR
              </Button>
              <Button
                variant="contained"
                fullWidth={isMobile}
                disabled={students.isLoading || exportedSudents.isLoading || downloadedReport.isLoading}
                endIcon={<Assessment />}
                onClick={() => handleClickReport()}
              >
                {downloadedReport.isLoading && <Spinner color="primary" />} REPORTE
              </Button>
              <Button
                variant="contained"
                fullWidth={isMobile}
                color="success"
                endIcon={<PersonAdd />}
                onClick={navigateNewStudent}
              >
                CARGAR
              </Button>

            </Box>
          </Grid>

          <Grid item xs={12}>
            <DataGrid
              slots={{ 
                columnMenu: CustomColumnMenu,
                toolbar: CustomToolbar,
                noRowsOverlay: CustomNoRowsOverlay,
                noResultsOverlay: CustomNoRowsOverlay
              }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              autoHeight={true}
              disableVirtualization={isMobile}
              rowSelection={false}
              getRowId={(row) => `${row.clientId}-${row.studentId}-${row.cuil}`}
              disableRowSelectionOnClick
              rows={rows}
              columns={columns}
              pageSizeOptions={[5, 10, 25, 50]}
              initialState={initializeDataGrid()}
              getRowHeight={() => (isMobile ? "auto" : undefined)}
              getEstimatedRowHeight={() => isMobile ? 150 : 52}
              sx={{
                "& .MuiDataGrid-footerContainer": {
                  justifyContent: isMobile ? "center" : "flex-end",
                },
                "& .MuiTablePagination-spacer": {
                  display: isMobile ? "none" : "block",
                },
                "& .MuiTablePagination-selectLabel": {
                  display: isMobile ? "none" : "block",
                },
                "& .MuiTablePagination-select": {
                  display: isMobile ? "none" : "flex",
                },
                "& .MuiTablePagination-toolbar": {
                  justifyContent: isMobile ? "center" : "flex-end",
                  width: isMobile ? "100%" : "auto",
                  paddingLeft: isMobile ? 0 : 2,
                },
              }}
            />
          </Grid>
        </Grid>
      )}

      {students.errors?.length > 0 && <ModalMessages errors={students.errors} />}
      {exportedSudents.errors?.length > 0 && <ModalMessages errors={exportedSudents.errors} />}
      {openModal && <ModalMails mails={mails} open={openModal} setOpen={setOpenModal} />}
    </>
  );
};

export default BackOfficeStudentsList;